import { api } from '../../lib/api.ts';

export type InviteStatus = 'PENDING' | 'SUBMITTED';

export interface Invite {
  id: string;
  vendorId: string;
  vendorName: string;
  vendorTypes: { id: string; name: string }[];
  status: InviteStatus;
  sentAt: string | null;
  deliveryError: string | null;
}

export interface SendForQuotesResult {
  sent: number;
  failed: { vendorName: string; vendorId: string; error: string }[];
  skipped: { vendorName: string; reason: 'no_email' }[];
  alreadyInvited: number;
}

export const invitesApi = {
  list: (requestId: string) =>
    api.get<{ invites: Invite[] }>(`/requests/${requestId}/invites`).then((r) => r.data.invites),
  sendForQuotes: (requestId: string, typeIds: string[], windowHours?: number) =>
    api
      .post<SendForQuotesResult>(`/requests/${requestId}/send-for-quotes`, { typeIds, windowHours })
      .then((r) => r.data),
  extendDeadline: (requestId: string, windowHours: number) =>
    api
      .patch<{ request: { id: string; deadline: string | null } }>(`/requests/${requestId}/deadline`, { windowHours })
      .then((r) => r.data.request),
  resend: (requestId: string, vendorId: string) =>
    api.post<{ ok: boolean; reason?: string }>(`/requests/${requestId}/invites/${vendorId}/resend`).then((r) => r.data),
};
